export default __webpack_public_path__ + "static/media/icons8-pdf.907889a2.svg";